import { IButtonConfig } from "../../../interfaces/Application/ButtonGroupStatus/IButtonConfig";

export const buttonConfigs: { [key: string]: IButtonConfig } = {
  rejectBank: {
    label: "Отказ",
    onClick: "rejectBank",
    className: "reject",
  },
  rejectClient: {
    label: "Отказ от заявки",
    onClick: "rejectClient",
    className: "reject",
  },
  addBank: {
    label: "Прикрепить Банки",
    onClick: "addBanks",
    className: "addBanks",
  },
  approve: {
    label: "Выпустить заявку",
    onClick: "issued",
    className: "approve",
  },
  forRevision: {
    label: "Вернуть на доработку",
    onClick: "forRevision",
    className: "forRevision",
  },
  inWork: {
    label: "Взять в работу",
    onClick: "inWork",
    className: "inWork",
  },
};
